import  i18n from 'src/locales/i18n';
import { ReactiveState, useReactiveStateHandler } from "reactive-state-handler";
import Amplify, { Auth } from "aws-amplify";
import awsConfig from "src/Constants/awsConfig";

import * as moment from "moment";
import "moment/locale/ar-dz";
import "moment/locale/fr";

export type AppStateType = {
  loggedIn: boolean;
  user: any;
  wilayas: any,
  city_name:any;
  state_name:any;
  jwt: string;
  loading: boolean;
  showSidebar: boolean;
  locale : "en" | "fr" | "ar"
};

class AppState extends ReactiveState {
  constructor(_: AppStateType) {
    super(_);
    Amplify.configure(awsConfig);
  }

  syncUser = async (_data: any) => {
    const [userData] = _data.Items || [];
    
    const _updatedUser = await Auth.currentAuthenticatedUser();
    _updatedUser.attributes = {
      ..._updatedUser.attributes,
      ...userData,
      "custom:city_id": `${userData.city_id}`,
      "custom:state_id": `${userData.state_id}`,
    };      
    localStorage.setItem("user", JSON.stringify(_updatedUser));
    this.setState({
      user: _updatedUser,
    });
  };

  loginUser = (user: any) => {
    this.loader();
    localStorage.setItem("user", JSON.stringify(user));
    this.setState({
      user,
      loggedIn: true,
    });
    console.log("user data",user)
  };

  setWilayas = (wilayas: any) => {
    this.setState({ wilayas: wilayas });
  }
  setLocation = (profileData: any) => {
    this.setState({ 
      city_name: profileData?.city_name,
      state_name:profileData?.state_name
     });
  }

  loader = () => {
    this.setState({
      loading: true,
    });
    setTimeout(() => {
      this.setState({
        loading: false,
      });
    }, 2000);
  };

  logout = () => {
    this.loader();
    localStorage.removeItem("user");
    this.setState({
      loggedIn: false,
    });
  };

  checkUserLogin = () => {
    this.loader();
    const userString = localStorage.getItem("user");
    if (userString) {
      const user = JSON.parse(userString);
      this.setState({
        user,
        loggedIn: true,
      });
    }
  };

  toggleSidebar = () => {
    const { showSidebar } = this.getState();
    this.setState({ showSidebar: !showSidebar });
  };

  startLoader = () => {
    this.setState({ loading: true })
  }

  stopLoader = () => {
    this.setState({ loading: false })
  }

  setLocale = (locale: "en" | "fr" | "ar" ) => {
    setTimestampsLocale(locale)
    i18n.changeLanguage(locale)
    localStorage.setItem("locale", JSON.stringify(locale));
    this.setState({ locale: locale })
  }
}

const AppStateHandler: AppState = new AppState({
  loggedIn: false,
  user: null,
  wilayas: null,
  city_name:null,
  state_name:null,
  jwt: "",
  loading: true,
  showSidebar: true,
  locale : i18n.language as "en" | "fr" | "ar"
})

export default AppStateHandler;

type addListener = () => void;

type removeListener = () => void;

export function useAppState(
  filterKeys?: Array<keyof AppStateType>
): [Partial<AppStateType>, removeListener, addListener] {
  return useReactiveStateHandler(AppStateHandler, filterKeys);
}


const setTimestampsLocale = (lang: string) => { 
  switch (lang) {
    case "en": moment.locale("en"); break;
    case "fr": moment.locale("fr"); break;
    case "ar": moment.locale("ar-dz"); break;
  }
}
// initial timestamps locale
setTimestampsLocale(i18n.language)